import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router';

import './i18n.js';
// Fonts and both themes of the new design (SP-UX10.1); the controls come in through styles.css.
import '../../../design/foundation/fonts.css';
import '../../../design/foundation/tokens.css';
import './styles.css';
import { ApiError } from './api/client.js';
import { router } from './router.js';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Client errors (4xx) do not get better by retrying.
      retry: (count, error) =>
        !(error instanceof ApiError && error.problem.status < 500) && count < 2,
      refetchOnWindowFocus: true,
    },
  },
});

const root = document.getElementById('root');
if (root) {
  createRoot(root).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
      </QueryClientProvider>
    </StrictMode>,
  );
}
